import { setTheme, useResolvedTheme } from "../../lib/theme";
import { SunIcon } from "../icons";
import { IconButton } from "../ui/button";

export function ThemeToggle() {
	const isDark = useResolvedTheme() === "dark";
	return (
		<IconButton
			aria-label="Dark theme"
			aria-pressed={isDark}
			onClick={() => {
				setTheme(isDark ? "light" : "dark");
			}}
		>
			<SunIcon />
		</IconButton>
	);
}
